import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

// NBO: free shipping is set per shipping zone in the store currency. Markets that show a local
// currency (AUD, CAD, SEK…) would otherwise be compared against a euro number, so the amount is
// converted here with Shopify's own rate — the same rate that converts the shipping rule itself.
function rate() {
  const value = parseFloat(window.Shopify?.currency?.rate);
  return Number.isFinite(value) && value > 0 ? value : 1;
}

async function cartTotal() {
  const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((response) =>
    response.json(),
  );
  return cart.total_price;
}

async function fixBar(bar) {
  const baseEl = bar.querySelector('[data-ref="nbo-step1-base"]');
  if (!baseEl) return;

  const currencyRate = rate();
  if (currencyRate === 1) return;

  const base = parseFloat(baseEl.dataset.base);
  if (!Number.isFinite(base)) return;

  const threshold = Math.round(base * currencyRate * 100);
  const total = await cartTotal();
  const label = bar.querySelector('.cart-progress-bar__label');
  const firstProgress = bar.querySelector('[data-ref="progress-bar"], progress');

  if (total >= threshold) {
    if (label && bar.dataset.nboCompletedText) label.textContent = bar.dataset.nboCompletedText;
    if (firstProgress) firstProgress.value = 100;
    return;
  }

  const missing = threshold - total;
  if (label && bar.dataset.nboStep1Text) {
    label.textContent = bar.dataset.nboStep1Text.replace('#', formatMoney(missing));
  }
  if (firstProgress) firstProgress.value = Math.min(100, (total / threshold) * 100);
}

function fixAll() {
  document.querySelectorAll('.cart-progress-bar').forEach((bar) => fixBar(bar));
}

// The drawer is re-rendered from server HTML in several ways (code auto-applied, cart opened,
// quantity changed…) and not all of them fire cartUpdated. Re-run whenever a bar is (re)inserted,
// otherwise the server's raw comparison in the wrong currency shows "free shipping" by mistake.
let pending;
function schedule() {
  clearTimeout(pending);
  pending = setTimeout(fixAll, 60);
}

document.addEventListener(ThemeEvents.cartUpdated, schedule);
if (ThemeEvents.cartOpen) document.addEventListener(ThemeEvents.cartOpen, schedule);
document.addEventListener('DOMContentLoaded', schedule);
if (document.readyState !== 'loading') schedule();

new MutationObserver((mutations) => {
  const barAdded = mutations.some((mutation) =>
    [...mutation.addedNodes].some(
      (node) =>
        node.nodeType === 1 &&
        (node.matches?.('.cart-progress-bar') || node.querySelector?.('.cart-progress-bar')),
    ),
  );
  if (barAdded) schedule();
}).observe(document.documentElement, { childList: true, subtree: true });
